import axios from 'axios';
import _ from 'lodash';

import { TOKEN, SESSION_CREATE_TIME } from '../constants/global';

axios.defaults.withCredentials = true;

export const PRODUCTION = 'production';
export const DEVELOPMENT = 'development';
export const STAGING = 'staging';
export const LOCAL = 'local';


const basicConfig = {
  [PRODUCTION]: {
    apiUrl: 'https://ebisujapan-chatbot.cobinyiuapp.com/ebisu_japan_system/api',
    // apiUrl: 'https://ebisu-japan-backend-prod-jmyewz3fmq-de.a.run.app/ebisu_japan_system/api',
    folderName: '/',
    showVersion: false,
    version: PRODUCTION,
    versionName: 'Basic Version'
  },
  [DEVELOPMENT]: {
    apiUrl: 'https://ebisu-japan-backend-jmyewz3fmq-de.a.run.app/ebisu_japan_system/api',
    folderName: '/ebisu-japan_dev',
    showVersion: true,
    version: DEVELOPMENT,
    versionName: 'v1.3.5'
  },
  // [STAGING]: {
  //   apiUrl: 'https://ebisu-japan-backend-jmyewz3fmq-de.a.run.app/ebisu_japan_system/api',
  //   endpointUrl: 'https://ebisu-japan-wish-item-liff-jmyewz3fmq-uc.a.run.app',
  //   folderName: '/ebisu-japan_demo',
  //   showVersion: true,
  //   version: STAGING,
  //   versionName: '測試版'
  // },
  // [LOCAL]: {
  //   apiUrl: '/api',
  //   endpointUrl: 'https://ebisu-japan-wish-item-liff-jmyewz3fmq-uc.a.run.app',
  //   folderName: '',
  //   showVersion: true,
  //   version: LOCAL,
  //   versionName: '本機版'
  // }
}

const currentStage = PRODUCTION;
// const currentStage = DEVELOPMENT;
// const currentStage = STAGING;
// const currentStage = LOCAL;

// api link
export const baseUrl = basicConfig[currentStage];

export const apiRequest = axios.create({
  baseURL: baseUrl.apiUrl,
})

export const apiList = {
  // User Status
  systemLogin: (data, config) => apiRequest.post('/authentication/system_login', data, config),
  // googleLogin: (data, config) => apiRequest.post(`/authentication/google_login?${data}`),
  loginout: (data, config) => apiRequest.post('/authentication/revoke', data, config),
  checkUserStatus: (data, config) => apiRequest.get('/authentication/me'),

  // Report: Summary
  getTotalUsers: (data, config) => apiRequest.get(`/report_overview/summary/total_users?${data}`),
  getTotalPurchaseUrls: (data, config) => apiRequest.get(`/report_overview/summary/total_purchase_urls?${data}`),
  getTotalUserQuestions: (data, config) => apiRequest.get(`/report_overview/summary/total_user_questions?${data}`),
  getHourlyUserQuestions: (data, config) => apiRequest.get(`/report_overview/summary/hourly_user_questions?${data}`),
  getTodayYesterdayUserQuestions: (data, config) => apiRequest.get(`/report_overview/summary/today_yesterday_user_questions?${data}`),
  getLastMonthThisMonthUserQuestions: (data, config) => apiRequest.get(`/report_overview/summary/last_month_this_month_user_questions?${data}`),

  // Report: Chart
  getQuestionProductTypes: (data, config) => apiRequest.get(`/report_overview/pie/question_product_types?${data}`),
  getEngagedButtonTypes: (data, config) => apiRequest.get(`/report_overview/square_pie/engaged_button_types?${data}`),
  getPopularQuestionProducts: (data, config) => apiRequest.get(`/report_overview/word_cloud/popular_question_products?${data}`),
  getGeneratedPruchaseUrls: (data, config) => apiRequest.get(`/report_overview/line/generated_pruchase_urls?${data}`),
  getUserQuestions: (data, config) => apiRequest.get(`/report_overview/line/user_questions?${data}`),

  // User List
  getUserList: (data, config) => apiRequest.get(`/report_overview/list/users?${data}`),
  putUserAiBlocked: (data, config) => apiRequest.put(`/report_overview/user?${data}`),
  getDownloadCsv: (data, config) => apiRequest.get(`/report_overview/list/users/download_csv?${data}`),

  // Marketing Word
  getObjectiveTypeList: (data, config) => apiRequest.get('/generation/objective_type/list'),
  getProductList: (data, config) => apiRequest.get(`/generation/product/list?${data}`),
  getGenerationText: (data, config) => apiRequest.get(`/generation/text?${data}`),
  putGenerationText: (data, config) => apiRequest.put(`/generation/text?${data.params}`, data.body)
}

export const handleApiRequest = (apiName, body, config) => {
  return apiList[apiName](body, {
    ...config
  })
    .then(res => {
      return res;
    })
    .catch(err => {
      return err.response || err;
    })
}

export const getCancelData = () => {
  return axios.CancelToken.source();
};

export const getToken = () => {
  return localStorage.getItem('token');
}

export const removeStorageRecord = () => {
  localStorage.removeItem(TOKEN);
  localStorage.removeItem(SESSION_CREATE_TIME);
  localStorage.removeItem('user');
}
